import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import Header from "../Components/header";
import imageSrc from "../imgs/DSC_8530.jpg";

export default function AboutUs() {
  const [age, setAge] = useState(null);

  useEffect(() => {
    const date = new Date();
    const birthDate = new Date(2004, 3, 11);
    const calculatedAge = Math.floor((date - birthDate) / 3.15576e10);
    setAge(calculatedAge);
  }, []);

  return (
    <div>
      <Header />
      <Helmet>
        <title>Modellistica International - Chi Siamo</title>
        <meta
          name="description"
          content="Scopri il mondo dell'aeromodellismo e modellismo con Modellistica International, la rivista dedicata agli appassionati."
        />
        <meta
          name="keywords"
          content="modellistica, aeromodelli, modellistica international, modellismo, abbonamenti modellismo, rivista modellistica abbonamento, chi siamo"
        />
      </Helmet>

      <div className="flex flex-col items-center py-8 px-6 lg:px-12 text-left bg-white min-h-screen">
        <h1 className="text-4xl font-bold mb-8 text-gray-800">Chi siamo</h1>

        <div className="flex flex-col lg:flex-row items-start gap-12 w-full max-w-6xl">
          <div className="flex-1">
            <p className="text-lg text-gray-700 leading-8 mb-8">
              Nel 1956 Vittorugo Chiodo fonda il "Giornale dell'aeromodellista",
              che nel 1958 diventa "
              <span className="font-semibold">Modellistica</span>", l'unica
              rivista italiana dell'epoca dedicata espressamente
              all'aeromodellismo, che diventa da subito il principale punto di
              riferimento degli aeromodellisti italiani. Dopo 42 anni di lavoro,
              Chiodo decide di "passare la mano" e il giornale viene rilevato
              dai suoi due principali collaboratori, Giulio e Marco Benincasa.
              Nasce così, nel 1998, Modellistica International, edita dalla
              International Press con sede a Viareggio (LU). Inizia così un
              nuovo ciclo, la rivista si rinnova, cambia veste grafica ed i
              contenuti coprono TUTTE le branche dell'aeromodellismo, con un
              occhio sempre attento alle nuove categorie e tipologie di
              aeromodelli. La filosofia su cui si basa il lavoro che porta alla
              creazione di un nuovo numero della rivista si può riassumere in
              alcune parole: puntualità di uscita, varietà di argomenti,
              copertura dei principali avvenimenti italiani ed internazionali.
              In sintesi, Modellistica International punta a far entrare nelle
              case degli aeromodellisti italiani tutto il meglio
              dell'aeromodellismo mondiale. A garanzia della qualità e della
              competenza con cui viene scelto il materiale, si noti che Giulio e
              Marco Benincasa sono da sempre NEL modellismo come ferventi
              praticanti ad altissimo livello conosciuti in tutto il mondo,
              anche nelle competizioni internazionali più prestigiose. Tra i
              collaboratori italiani e stranieri spiccano aeromodellisti esperti
              e prestigiosi, e molto spesso sono proprio i migliori della loro
              categoria. Un importante riconoscimento alla serietà ed alla
              professionalità dello staff di Modellistica arriva nel 1998,
              quando "Modellistica International" viene chiamata a far parte
              della giuria del prestigioso premio mondiale "Modello dell'Anno"
              (Model Of the Year Award) insieme alle migliori sei riviste del
              mondo. Nel 2003 viene fondata "Volo Elettrico", trimestrale
              dedicato integralmente ai modelli volanti con propulsione
              elettrica, ed è subito un successo; da Gennaio del 2014, vista
              l'enorme espansione della motorizzazione elettrica
              nell'aeromodellismo, e finito il bisogno di una rivista
              esclusivamente dedicata a questa tipologia, "Volo Elettrico" viene
              inglobata in Modellistica International. Se cercate articoli
              tecnici sia pratici che teorici, presentazioni dei nuovi prodotti
              disponibili sul mercato, reportage dei più importanti eventi
              italiani ed esteri, tutte le notizie che riguardano il nostro
              meraviglioso hobby e tutto quello che potete desiderare da una
              rivista di aeromodellismo, la vostra ricerca è finita, avete
              trovato Modellistica International.
            </p>
          </div>

          <div className="flex flex-col items-center">
            <img
              src={imageSrc}
              alt="Marco Benincasa"
              className="w-80 h-80 lg:w-96 lg:h-96 object-cover shadow-lg rounded-lg hover:scale-105 transform transition duration-300 ease-in-out"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
